import axios from "axios";

export default {
  async loadInitData({commit, state}) {
    const response = await axios.get('admin/home')
    commit('setSettingGroups', response.data.data.response.setting_groups);
    commit('setAdmin', response.data.data.response.admin);
    commit('setCountUnreadGuides', response.data.data.response.count_unread_guides)
    commit('setTodaySumSell', response.data.data.response.today_sum_sell)
    commit('setTotalSumSell', response.data.data.response.total_sum_sell)    
    // let sG = response.data.data.response.setting_groups;
    // sG.forEach((g) => {
    //   g.title = g.label
    //   delete g.label
    //   g.to = '/admin/settings/' + g.name
    //   g.children = []
    //   g.permissions = ['public']
    // })
    // commit('addToMenu', {title:'تنظیمات' , icon:'fe fe-sliders', to:'' , children: sG , permissions:['read_setting']} );

  },
  showLoading({commit, state}, onlyWhenNotInitialized = true) {
    if (onlyWhenNotInitialized && this.getters.initialized) {
      return;
    }
    commit('incrementLoading')
  },
  hideLoading({commit,state}, onlyWhenNotInitialized = true) {
    if (onlyWhenNotInitialized && this.getters.initialized && state.loading === 0) {
      return;
    }
    commit('decrementLoading')
  },

}
